import React, { useState } from 'react';
import dayjs from 'dayjs';

import Button from '../../../../components/Button/Button';
import SelectClients from '../../../../components/Selects/SelectClients';
import ClientCreateModal from '../../../../components/ClientCreateModal/ClientCreateModal';
import { colors } from '../../../../constants/colors';

// getClients отдаёт документ вложенным объектом, а адрес — по частям.
const documentOf = (client) => {
  const doc = client?.document;
  if (!doc?.document_number) return '';
  const issued = doc.document_date ? ` от ${dayjs(doc.document_date).format('DD.MM.YYYY')}` : '';
  return `${doc.document_number}${issued}`;
};

const addressOf = (client) =>
  [
    client?.city?.title,
    client?.registration_street,
    client?.registration_house_number && `д. ${client.registration_house_number}`,
    client?.registration_apartment_number && `кв. ${client.registration_apartment_number}`,
  ]
    .filter(Boolean)
    .join(', ');

const Row = ({ label, value }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', padding: '6px 0' }}>
    <span style={{ color: colors.dimGray }}>{label}</span>
    <span style={{ color: colors.blackPearl }}>{value || '—'}</span>
  </div>
);

/**
 * Блок «Продавец» договора поручения. Продавец — обычный клиент CRM, поэтому
 * он либо создаётся здесь же (eGov / вручную) в модалке, либо выбирается из базы.
 */
const SellerBlock = ({ seller, onChange, error }) => {
  const [modal, setModal] = useState(false);
  const [picking, setPicking] = useState(false);

  const client = seller?.client;

  return (
    <>
      {seller ? (
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 10,
            }}
          >
            <span style={{ fontSize: 18, fontWeight: 600, color: colors.blackPearl }}>
              {client ? `${client.surname || ''} ${client.name || ''} ${client.middlename || ''}`.trim() : seller.label}
            </span>
            <span
              role="button"
              onClick={() => onChange(null)}
              style={{ color: colors.cameo, textDecoration: 'underline', cursor: 'pointer' }}
            >
              Выбрать другого
            </span>
          </div>
          <Row label="ИИН" value={client?.iin} />
          <Row label="Телефон" value={client?.phone} />
          <Row label="Документ" value={documentOf(client)} />
          <Row label="Адрес" value={addressOf(client)} />
        </div>
      ) : (
        <>

          {picking ? (
            <div style={{ maxWidth: 520 }}>
              <SelectClients value={seller} onChange={onChange} error={!!error} />
              <span
                role="button"
                onClick={() => setPicking(false)}
                style={{
                  display: 'inline-block',
                  marginTop: 12,
                  color: colors.cameo,
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                Отмена
              </span>
            </div>
          ) : (
            <div style={{ display: 'flex', gap: 12 }}>
              <Button text="Добавить нового клиента" fill onClick={() => setModal(true)} />
              <Button text="Выбрать существующего клиента" onClick={() => setPicking(true)} />
            </div>
          )}

          {error && <p style={{ color: colors.red, marginTop: 12 }}>{error}</p>}
        </>
      )}

      <ClientCreateModal
        isOpen={modal}
        onRequestClose={() => setModal(false)}
        hideKato
        hideLanguage
        onCreated={(option) => {
          onChange(option);
          setPicking(false);
        }}
      />
    </>
  );
};

export default SellerBlock;
